import {string, shape} from 'prop-types';

const GenderResourceType = {
  label: string,
  data: shape({
    male: string,
    female: string,
  }),
};

export default GenderResourceType;
